import React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

type Props = {
  title: any
  children: any
  defaultExpanded?: boolean
  className?: string
  postfix?: any
}

const CustomAccordion = (props: Props) => {
  const { title, children, defaultExpanded, className, postfix } = props
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px !important',
      }}
      className={className || ''}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className="text-secondaryText" />}
        aria-controls="panel3-content"
        id="panel3-header"
        sx={{
          bgcolor: 'secondary.main',
          borderRadius: '8px',
        }}
        className="text-secondary"
      >
        <div className="w-full flex justify-between">
          <h2 className="font-bold break-all">{title}</h2>
          {postfix || ''}
        </div>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}

export default CustomAccordion
